import React from 'react';
import Layout from '../../components/Layout';
import NextHead from 'next/head';

export default function Service() {
  return (
    <Layout>
      <NextHead>
        <title>BGMs - 이용약관</title>
        <meta name="description" content="BGMs (브금쓰)로 YouTube 플레이리스트를 공유하고, 공간에 음악을 채워보세요." />
        <meta property="og:title" content="BGMs - 이용약관" />
        <meta name="subject" content="BGMs (브금쓰)로 YouTube 플레이리스트를 공유하고, 공간에 음악을 채워보세요." />
        <meta property="og:description" content="BGMs (브금쓰)로 YouTube 플레이리스트를 공유하고, 공간에 음악을 채워보세요." />
        <meta property="og:url" content="https://bgms.live/policy/service" />
        <meta
          name="twitter:image"
          content="https://bgms-bucket.s3.ap-northeast-2.amazonaws.com/channel/image/bgmsMetaImg.jpg"
        />
        <meta name="twitter:domain" content="https://bgms.live/policy/service" />
        <meta name="twitter:title" content="BGMs - 이용약관" />
        <meta name="twitter:description" content="BGMs (브금쓰)로 YouTube 플레이리스트를 공유하고, 공간에 음악을 채워보세요." />
      </NextHead>

      <div className="max-w-4xl mx-auto px-6 py-16 animate-fade-in">
        {/* Header */}
        <div className="mb-16">
          <div className="inline-block px-4 py-1 bg-lime/10 text-lime rounded-full text-sm font-bold mb-4">
            Terms of Use
          </div>
          <h1 className="text-5xl font-bold mb-6 text-white">이용약관</h1>
          <div className="space-y-2 text-gray-d leading-relaxed">
            <p>BGMs 서비스 이용에 필요한 사항을 명시합니다</p>
            <p className="text-lime font-semibold mt-4">시행일자: 2022년 11월 1일</p>
          </div>
        </div>

        {/* Language Notice */}
        <div className="mb-6 p-4 bg-blue-500/10 border border-blue-500/30 rounded-lg">
          <p className="text-blue-400 text-sm font-semibold">
            ℹ️ 언어 안내: 본 이용약관은 한국어로만 제공됩니다. / This Terms of Service is available in Korean only. / この利用規約は韓国語でのみ提供されます。
          </p>
        </div>

        {/* Content */}
        <div className="space-y-12 text-gray-d leading-relaxed">
          {/* 총칙 */}
          <div>
            <h2 className="text-3xl font-bold text-white mb-8">총칙</h2>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제1조 (목적)</h3>
              <p>
                이 약관은 주식회사 도들랩 (이하 '회사')가 제공하는 BGMs서비스 (이하 'BGMs')의 이용과 관련하여 '회사'와
                '회원'간 권리와 의무 및 기타 필요한 사항을 규정하는데 그 목적이 있습니다.
              </p>
            </section>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제2조 (용어의 정의)</h3>
              <p className="mb-4">이 약관에서 사용하는 용어의 정의는 아래와 같습니다.</p>
              <ol className="space-y-2 list-decimal list-inside ml-4">
                <li>'BGMs'라 함은 '회사'가 '회원'에게 제공하는 소프트웨어 이용 등 관련 제반 서비스를 의미합니다.</li>
                <li>
                  '회원'이라 함은 'BGMs'에 접속하여 본 약관에 따라 '회사'와 이용계약을 체결하고 '회사'가 제공하는
                  'BGMs'를 이용하는 자를 의미합니다.
                </li>
                <li>
                  '아이디(ID)'라 함은 '회원'의 식별과 'BGMs' 이용을 위하여 '회원'이 정하는 전자우편주소를 의미합니다.
                </li>
                <li>
                  '비밀번호'라 함은 '회원'이 설정한 '아이디'와 일치되는 '회원'임을 확인하고 비밀보호를 위해 '회원' 자신이
                  정한 문자, 숫자 또는 부호의 조합을 의미합니다.
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제3조 (약관의 게시와 개정)</h3>
              <ol className="space-y-3 list-decimal list-inside ml-4">
                <li>
                  '회사'는 이 약관의 내용을 '회원'이 쉽게 알 수 있도록 'BGMs' 홈페이지(이하 '서비스 홈페이지') 초기 화면에
                  게시합니다. 또한 '회사'는 이 약관을 '회원'이 그 전부를 쉽게 확인할 수 있도록 기술적 조치를 취합니다.
                </li>
                <li>
                  '회사'는 약관의 규제에 관한 법률, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 관련 법령을 위배하지
                  않는 범위에서 본 약관을 개정할 수 있습니다.
                </li>
                <li>
                  '회사'가 이 약관을 개정하고자 할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 제1항의 방식에
                  따라 그 개정약관의 적용일자 7일전부터 적용일자 전일까지 공지합니다. 다만, '회원'에게 불리한 약관 개정의
                  경우에는 30일 전부터 공지를 진행함과 아울러 일정기간 '아이디'로 등록된 전자우편주소로 명확히 통지합니다.
                </li>
                <li>
                  '회사'가 전항에 따라 개정약관을 공지 또는 통지하면서 '회원'에게 공지 기간 내에 거부의 의사표지를 하지
                  않으면 약관 개정에 동의한 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 '회원'이 명시적으로 거부의
                  의사표시를 하지 아니한 경우 '회원'이 개정약관에 동의한 것으로 봅니다.
                </li>
                <li>
                  '회원'이 개정약관의 적용에 동의하지 않는 경우 '회사'는 개정약관의 내용을 적용할 수 없으며, 이 경우
                  '회원'은 이용계약을 해지할 수 있습니다. 다만, 기존약관을 적용할 수 없는 특별한 사정이 있는 경우에는
                  '회사'가 '회원'과의 이용계약을 해지할 수 있습니다.
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제4조 (약관의 해석)</h3>
              <ol className="space-y-2 list-decimal list-inside ml-4">
                <li>
                  '회사'는 'BGMs'를 위하여 별도의 정책을 둘 수 있으며, 이를 '회원'이 확인할 수 있도록 '서비스 홈페이지'
                  등에 게시합니다. '회사'가 게시한 정책 내용이 이 약관과 상충될 경우 별도의 정책이 우선하여 적용됩니다.
                </li>
                <li>이 약관에서 정하지 아니한 사항이나 해석에 대해서는 전항의 정책, 관련 법령 또는 상관례에 따릅니다.</li>
              </ol>
            </section>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제5조 ('BGMs' 이용계약 체결 등)</h3>
              <ol className="space-y-3 list-decimal list-inside ml-4">
                <li>
                  'BGMs' 이용계약은 '회원'이 되고자 하는 자(이하 '가입신청자')가 이 약관의 내용에 대하여 동의를 한 다음
                  회원가입신청을 하고 '회사'가 이러한 신청에 대하여 승낙함으로써 체결됩니다.
                </li>
                <li>
                  '회사'는 '가입신청자'의 신청에 대하여 'BGMs' 이용을 승낙함을 원칙으로 합니다. 다만, '회사'는 아래 각 호에
                  해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.
                  <div className="ml-6 mt-2 space-y-2">
                    <p>
                      가. 정보주체는 주식회사 도들랩에 대해 언제든지 개인정보 열람, 정정, 삭제, 처리정지 요구 등의 권리를
                      행사할 수 있습니다.
                      <br />
                      <span className="text-sm ml-4">
                        (단, '회사'의 '회원' 재가입 승낙을 얻은 경우에는 예외로 함)
                      </span>
                    </p>
                    <p>나. 실명이 아니거나 타인의 명의를 이용한 경우</p>
                    <p>다. 허위의 정보를 기재하거나, '회사'가 요청하는 내용을 기재하지 않은 경우</p>
                    <p>라. 위법, 불법행위 등 부정한 용도로 'BGMs'를 이용하고자 하는 경우</p>
                    <p>
                      마. '가입신청자'의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하여 신청하는 경우
                    </p>
                  </div>
                </li>
                <li>제1항의 회원가입신청에 있어 '회사'는 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.</li>
                <li>
                  '회사'는 'BGMs' 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수
                  있습니다.
                </li>
                <li>
                  본 조에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, '회사'는 원칙적으로 이를
                  '가입신청자'에게 알립니다.
                </li>
                <li>
                  'BGMs' 이용계약의 성립 시기는 '회사'가 회원가입신청에 대한 완료를 신청절차 상에서 표시한 시점으로 합니다.
                </li>
                <li>
                  '회원'이 회원가입신청 시 제공한 개인정보는 관련 법령 및 '회사'의 개인정보취급방침의 적용을 받습니다.
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제6조 (정보의 변경)</h3>
              <ol className="space-y-2 list-decimal list-inside ml-4">
                <li>
                  '회원'은 개인정보관리 화면을 통하여 언제든지 본인의 정보를 열람하고 수정할 수 있습니다. 다만, 'BGMs'
                  관리를 위해 필요한 실명, '아이디' 등 '회사'가 수정을 불허하는 항목의 수정은 '회사'와 사전 합의가
                  필요합니다.
                </li>
                <li>
                  '회원'은 회원가입신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편 기타 방법으로
                  '회사'에 대하여 그 변경사항을 알려야 합니다.
                </li>
                <li>
                  '회원'이 자신의 정보에 대한 변경사항을 적절히 수정하지 않아 발생한 불이익에 대하여 '회사'는 책임을 부담하지
                  않습니다.
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제7조 (개인정보 보호 의무)</h3>
              <ol className="space-y-2 list-decimal list-inside ml-4">
                <li>
                  '회사'는 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 관련 법령이 정하는 바에 따라 '회원'의
                  개인정보를 보호하기 위해 노력합니다.
                </li>
                <li>
                  개인정보의 보호 및 사용에 대해서는 관련 법령 및 '회사'의 개인정보처리방침이 적용됩니다. 다만, '회사'의
                  공식 사이트 이외의 링크된 사이트에서는 '회사'의 개인정보처리방침이 적용되지 않습니다.
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제8조 ('아이디' 및 '비밀번호'의 관리에 대한 의무)</h3>
              <ol className="space-y-2 list-decimal list-inside ml-4">
                <li>
                  '회원' 및 '구성원'의 '아이디'와 '비밀번호'에 관한 관리책임은 '회원' 및 '구성원'에게 있으며, 이를 제3자가
                  이용하도록 하여서는 안 됩니다.
                </li>
                <li>
                  '회사'는 '회원' 또는 '구성원'의 '아이디' 또는 개인정보가 유출 우려가 있거나, 반사회적 또는 미풍양속에
                  어긋나거나 '회사' 및 '회사'의 운영자로 오인될 우려가 있는 경우, 해당 '아이디'의 이용을 제한할 수 있습니다.
                </li>
                <li>
                  '회원'은 '아이디' 및 '비밀번호'가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 '회사'에
                  통지하고 '회사'의 안내에 따라야 합니다.
                </li>
                <li>
                  제3항의 경우에 해당 '회원'이 '회사'에 그 사실을 통지하지 않거나, 통지 후 '회사'의 안내에 따르지 않아 발생한
                  불이익에 대하여 '회사'는 책임을 부담하지 않습니다.
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제9조 ('회원'에 대한 통지)</h3>
              <ol className="space-y-2 list-decimal list-inside ml-4">
                <li>
                  '회사'가 '회원'에 대한 통지를 하는 경우 이 약관에 별도 규정이 없는 한 '아이디'로 등록한 전자우편주소로 할
                  수 있습니다.
                </li>
                <li>
                  '회사'가 '관리자'에게 통지한 경우 이는 '회원'에게 통지한 것으로 봅니다. '회원'은 '관리자' 정보에 대한 관리
                  및 적절한 정보로의 변경 책임을 부담합니다.
                </li>
                <li>
                  '회원' 전체에 대한 통지의 경우 '회사'는 7일 이상 '서비스 홈페이지' 게시판에 해당 내용을 게시함으로써 전항의
                  통지를 갈음할 수 있습니다.
                </li>
                <li>'회원'은 '회사'가 '회원'에게 통지한 사항에 대하여 '구성원'에게 통지할 책임을 부담합니다.</li>
              </ol>
            </section>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제10조 ('회사'의 의무)</h3>
              <ol className="space-y-2 list-decimal list-inside ml-4">
                <li>
                  '회사'는 관련 법령과 이 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로
                  'BGMs'를 제공하기 위하여 최선을 다하여 노력합니다.
                </li>
                <li>
                  '회사'는 '회원'이 안전하게 'BGMs'를 이용할 수 있도록 개인정보 보호를 위해 보안시스템을 갖추어야 하며
                  개인정보취급방침을 공시하고 준수합니다.
                </li>
                <li>
                  '회사'는 'BGMs' 이용과 관련하여 발생하는 '회원'의 불만 또는 피해구제요청을 적절하게 처리할 수 있도록
                  필요한 인력 및 시스템을 구비합니다.
                </li>
                <li>
                  '회사'는 'BGMs' 이용과 관련하여 '회원'으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를
                  처리하여야 합니다. '회원'이 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여
                  '회원'에게 처리과정 및 결과를 전달할 수 있습니다.
                </li>
                <li>
                  '회사'가 '회원'에 대한 'BGMs'의 제공이 불가능해지는 경우, '회사'는 'BGMs'의 제공 중지일자의 3개월 전까지
                  제9조에서 정한 방법으로 '회원'에게 통지합니다. 다만, '회사'가 3개월 전에 통지할 수 없는 부득이한 사유가
                  있는 경우 '회사'는 'BGMs'를 제공할 수 없게 된 날까지 '회원'에게 통지하는 것으로 3개월 전 통지의무를
                  갈음할 수 있습니다.
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제11조 ('회원'의 의무)</h3>
              <p className="mb-3">'회원'은 아래 각 호의 행위를 하여서는 안 됩니다.</p>
              <div className="ml-4 space-y-2">
                <p>가. 회원가입신청 또는 기입정보의 변경 시 허위내용의 등록</p>
                <p>나. 타인의 정보도용</p>
                <p>다. '회사'가 게시한 정보의 변경</p>
                <p>
                  라. 불법소프트웨어 등 법령에서 금지하거나 '회사'가 공지사항 등을 통해 금지하는 소프트웨어 등 정보의 복제,
                  전송, 공유하는 행위
                </p>
                <p>마. '회사' 및 기타 제3자의 저작권 등 지적재산권에 대한 침해</p>
                <p>바. '회사' 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</p>
                <p>
                  사. 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 'BGMs'를 이용하여 복제, 전송,
                  방송, 공유하는 행위
                </p>
                <p>아. '회사'의 동의 없이 영리를 목적으로 'BGMs'를 사용하는 행위</p>
                <p>자. 기타 불법적이거나 부당한 행위</p>
              </div>
            </section>
          </div>

          {/* BGMs 이용 */}
          <div>
            <h2 className="text-3xl font-bold text-white mb-8">BGMs 이용</h2>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제12조 ('BGMs'의 제공 등)</h3>
              <ol className="space-y-2 list-decimal list-inside ml-4">
                <li>'회사'는 'BGMs'의 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.</li>
                <li>
                  '회사'는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우
                  'BGMs'의 제공을 일시적으로 중단할 수 있습니다. 이 경우 '회사'는 'BGMs'의 제공이 중단되기 3일전에
                  제9조에서 정한 방법으로 '회원'에게 통지합니다. 다만, '회사'가 사전에 통지할 수 없는 부득이한 사유가 있는
                  경우 사후에 통지할 수 있습니다.
                </li>
                <li>
                  '회사'는 'BGMs'의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 '서비스 홈페이지'에
                  공지한 바에 따릅니다.
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제13조 ('BGMs'의 변경)</h3>
              <ol className="space-y-2 list-decimal list-inside ml-4">
                <li>
                  '회사'는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 'BGMs'의 전부 또는 일부를 변경할 수
                  있습니다.
                </li>
                <li>
                  'BGMs'의 내용, 이용방법, 이용시간, 이용금액에 대하여 변경이 있는 경우에는 변경사유, 변경될 내용 및
                  제공일자 등은 그 변경 전에 '서비스 홈페이지'에 게시하여야 합니다.
                </li>
                <li>'회원'은 본 조에 의한 'BGMs'의 변경에 동의하지 않을 경우 'BGMs' 이용계약을 해지할 수 있습니다.</li>
              </ol>
            </section>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제14조 ('BGMs' 정보 제공 및 안내)</h3>
              <ol className="space-y-2 list-decimal list-inside ml-4">
                <li>
                  '회사'는 '회원'이 'BGMs' 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편 등의 방법으로
                  '회원'에게 제공할 수 있습니다.
                </li>
                <li>
                  제1항의 정보를 전화 및 모사전송기기에 의하여 전송하려고 하는 경우에는 '회원'의 사전 동의를 받아서
                  전송합니다. 다만, '회원'의 거래관련 정보 및 고객문의 등에 대한 회신에 있어서는 제외됩니다.
                </li>
                <li>
                  '회사'는 'BGMs'의 운영과 관련하여 'BGMs' 화면, '서비스 홈페이지' 등에 서비스 이용과 관련된 안내 내용을
                  게재할 수 있습니다. 안내 내용이 게재된 전자우편을 수신한 '회원'은 '회사'에 대하여 그 수신을 거절할 수
                  있습니다.
                </li>
                <li>
                  '회원'은 'BGMs'와 관련하여 '회사'가 게시・제공하는 게시물 또는 기타 정보를 변경, 수정, 제한하는 등의
                  조치를 취하지 않습니다.
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제15조 (광고의 게제)</h3>
              <ol className="space-y-2 list-decimal list-inside ml-4">
                <li>
                  '회사'는 'BGMs' 운영과 관련하여 회원정보, '회원'이 입력한 정보를 활용하여 광고를 게재할 수 있습니다.
                  회원은 서비스 이용 시 노출되는 맞춤 광고 게재에 대해 동의합니다.
                </li>
                <li>
                  '회사'는 서비스상에 게재되어 있거나 서비스를 통한 광고주의 판촉활동에 회원이 참여하거나 교신 또는 거래를
                  함으로써 발생하는 손실과 손해에 대해 책임을 지지 않습니다.
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제16조 (이용제한 등)</h3>
              <ol className="space-y-2 list-decimal list-inside ml-4">
                <li>
                  '회사'는 '회원'이 약관을 위반하거나 '회원'이 'BGMs'의 정상적인 운영을 방해한 경우, 경고, 일시정지,
                  영구이용정지 등으로 '회원'의 'BGMs' 이용을 단계적으로 제한할 수 있습니다.
                </li>
                <li>
                  '회사'는 전항에도 불구하고 명의도용 및 결제도용, 저작권법을 위반한 불법프로그램의 제공 및 운영방해,
                  정보통신망 이용촉진 및 정보보호 등에 관한 법률을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한
                  초과행위 등과 같이 관련 법령을 위반한 경우에는 즉시 영구이용정지를 할 수 있습니다. 본 항에 따른
                  영구이용정지 시 'BGMs' 이용을 통해 획득한 기타 혜택 등도 모두 소멸되며, '회사'는 이에 대해 별도로
                  보상하지 않습니다.
                </li>
                <li>'회사'는 본 조의 이용제한 범위 내에서 제한의 조건 및 세부내용을 개별 운영정책으로 정할 수 있습니다.</li>
                <li>
                  본 조에 따라 'BGMs' 이용을 제한하거나 계약을 해지하는 경우에는 '회사'는 이의신청 방법과 함께 제9조에 따라
                  통지합니다.
                </li>
                <li>
                  '회원'은 본 조에 따른 이용제한 등에 대해 '회사'가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가
                  정당하다고 '회사'가 인정하는 경우 '회사'는 즉시 'BGMs'의 이용을 재개합니다.
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제17조 (청약철회, 계약해지 등)</h3>
              <ol className="space-y-2 list-decimal list-inside ml-4">
                <li>
                  소비자의 사용 또는 일부 소비로 재화 등의 가치가 현저히 감소하기 때문에 단순변심으로 인한 환불은 불가합니다.
                </li>
                <li>
                  '회원'은 언제든지 '서비스 홈페이지' 상에서 'BGMs' 이용계약 해지 신청을 할 수 있으며, '회사'는 관련 법령
                  등이 정하는 바에 따라 이를 즉시 처리하여야 합니다.
                </li>
                <li>
                  '회사'는 아래 각호의 경우에 '회원'과의 이용계약을 해지할 수 있습니다.
                  <div className="ml-6 mt-2 space-y-1">
                    <p>가. '회원'이 회생절차 또는 파산을 신청하였거나, 신청한 경우</p>
                    <p>나. '회원'이 'BGMs'을 불법적인 용도로 사용하였거나, 불법정보를 유통한 경우</p>
                    <p>다. '회원'이 이 약관을 위반하고 '회사'의 시정요청을 7영업일 이내에 이행하지 않은 경우</p>
                    <p>라. '회원'이 이용금액을 납부하지 않았을 경우</p>
                  </div>
                </li>
                <li>
                  '회원'의 'BGMs' 이용계약 해지 시 'BGMs' 관련 데이터는 모두 삭제됩니다. '회원'은 'BGMs' 이용계약 해지 전
                  '회원'의 데이터를 스스로 백업하여야 하며, '회원'이 데이터를 백업하지 않아 발생한 문제에 대해 '회사'는
                  책임을 부담하지 않습니다
                </li>
              </ol>
            </section>
          </div>

          {/* 기타 */}
          <div>
            <h2 className="text-3xl font-bold text-white mb-8">기타</h2>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제18조 (손해배상)</h3>
              <p>
                '회사' 또는 '회원'의 귀책사유로 인하여 상대방 또는 제3자에게 손해가 발생할 경우 귀책당사자는 해당 손해를
                배상하여야 합니다.
              </p>
            </section>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제19조 (권리의 귀속)</h3>
              <ol className="space-y-2 list-decimal list-inside ml-4">
                <li>'BGMs'에 대한 저작권 등 지적재산권은 '회사'에 귀속됩니다.</li>
                <li>
                  '회사'는 '회원'에게 이 약관을 포함하여 '회사'가 사전에 정하여 공지 또는 통지한 이용조건에 따라 'BGMs'를
                  이용할 수 있는 이용권만을 부여하며, '회원'은 이를 양도 또는 판매하거나, 담보로 제공하는 등 처분행위를
                  하여서는 안 됩니다.
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">제20조 (준거법 및 재판관할)</h3>
              <ol className="space-y-2 list-decimal list-inside ml-4">
                <li>'회사'와 '회원' 간 제기된 소송은 대한민국법을 준거법으로 합니다.</li>
                <li>
                  '회사'와 '회원'간 발생한 분쟁의 경우 관할법원은 민사소송법이 정한 바에 따릅니다. 다만, 해외에 주소나
                  거소가 있는 '회원'의 경우 '회사'와 '회원' 간 발생한 분쟁에 관한 소송은 본문에도 불구하고
                  서울중앙지방법원을 관할 법원으로 합니다.
                </li>
              </ol>
            </section>
          </div>

          {/* 부칙 */}
          <div>
            <h2 className="text-3xl font-bold text-white mb-4">부칙</h2>
            <p className="text-lime">본 약관은 2022년 11월 1일부터 적용됩니다.</p>
          </div>
        </div>
      </div>
    </Layout>
  );
}
